/**
 * Набор карт eShop на сумму: минимум рублей с штрафом за каждый лишний код,
 * при равенстве — меньше кодов, затем меньше переплата. Как card-pick.js на бэкенде.
 */

const CENT = 100;
export const CODE_PENALTY_RUB = 150;
const MAX_CODES = 10;

function isBetter(a, b) {
  if (!b) return true;
  if (a.cost !== b.cost) return a.cost < b.cost;
  if (a.codes !== b.codes) return a.codes < b.codes;
  return a.overpay < b.overpay;
}

function summarize(best, denoms) {
  const items = denoms
    .map((d, i) => ({ ...d, quantity: best.counts[i] }))
    .filter((item) => item.quantity > 0);
  const sum = (key) =>
    items.reduce((acc, item) => acc + item[key] * item.quantity, 0);
  return {
    items,
    codes: best.codes,
    face: sum("cents") / CENT,
    rub: sum("priceRub"),
    overpay: best.overpay / CENT,
  };
}

/** Цена в рублях по самому выгодному курсу карт в наличии, как rate на бэкенде. null — карт нет. */
export function rubAtCardRate(amount, denominations) {
  const rates = (denominations || [])
    .filter((d) => d.stock > 0 && d.face > 0 && d.priceRub > 0)
    .map((d) => d.priceRub / d.face);
  return rates.length && amount > 0 ? Math.round(amount * Math.min(...rates)) : null;
}

/** denominations: [{ face, priceRub, stock }]. null — карт в наличии не хватает. */
export function pickCards(
  need,
  denominations,
  { codePenaltyRub = CODE_PENALTY_RUB, maxCodes = MAX_CODES } = {},
) {
  const needCents = Math.max(0, Math.round(need * CENT));
  if (needCents === 0) {
    return { items: [], codes: 0, face: 0, rub: 0, overpay: 0 };
  }
  const denoms = (denominations || [])
    .filter((d) => d.stock > 0 && d.face > 0)
    .map((d) => ({ ...d, cents: Math.round(d.face * CENT) }))
    .sort((a, b) => b.cents - a.cents);

  const counts = new Array(denoms.length).fill(0);
  let best = null;

  function walk(index, sum, codes, rub) {
    if (sum >= needCents) {
      const candidate = {
        cost: rub + codePenaltyRub * codes,
        codes,
        overpay: sum - needCents,
        counts: counts.slice(),
      };
      if (isBetter(candidate, best)) best = candidate;
      return;
    }
    if (index >= denoms.length || codes >= maxCodes) return;
    const d = denoms[index];
    for (let n = Math.min(d.stock, maxCodes - codes); n >= 0; n -= 1) {
      counts[index] = n;
      walk(index + 1, sum + n * d.cents, codes + n, rub + n * d.priceRub);
    }
    counts[index] = 0;
  }

  walk(0, 0, 0, 0);
  return best ? summarize(best, denoms) : null;
}
